import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    id: 't.header',
    defaultMessage: 'This is a shared station.',
  },
  bodyMessage: {
    id: 't.body',
    defaultMessage:
      'Would you like to make it your own station? When you thumb a song while listening to a shared station, you take control of it.',
  },
  button1: {
    id: 't.button1',
    defaultMessage: 'Continue',
  },
  button2: {
    id: 't.button2',
    defaultMessage: 'Cancel',
  },
});
